import mapStyle from "./mapStyle";
export default mapStyle;